import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { apiGet } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isClient = !loading && user && user.role === "client";

  // Client accounts only ever see the client portal — resolve their link and go.
  React.useEffect(() => {
    if (!isClient) return;
    apiGet("/client/portal-link")
      .then((r) => {
        if (r?.url_path) window.location.replace(r.url_path);
      })
      .catch(() => {});
  }, [isClient]);

  if (loading || isClient) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="overline">Loading</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
}
